import * as React from "react"


export default function FiltersLoading() {
    return <div className="loadingFilters">
        <div style={{ width: '100%', display: 'flex' }}>
            <div className="actions" style={{ marginRight: '16px' }} />
            <div className="actions" style={{ marginRight: '16px' }} />
            <div className="actions" />
        </div>
        <div style={{ width: '100%', display: 'flex', marginTop: '10px' }}>
            <div className="actions-two" style={{ marginRight: '16px' }} />
            <div className="actions-two" />
        </div>
        <div className="actions-btn" style={{ marginTop: '10px', justifyContent: 'flex-end' }} />
    </div>
}